import { useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";

export default function Terms() {
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    let lang =
      localStorage?.getItem("language") ||
      navigator.language ||
      navigator.userLanguage;

    if (lang === "fr") lang = "fr-FR";

    const basePath = lang === "fr-FR" ? "/fr" : "/en";
    const newPath = `${basePath}${location.pathname}`;

    navigate(newPath, { replace: true });
  }, []);

  console.log("loaded");
  return null;
}
